<script setup>
const props = defineProps({
  siteTitle: String,
  viewport: String,
});

const configs = useRuntimeConfig().public;

const site = useState("site", () => ({
  siteTitle: "",
}));

if (!site.value.siteTitle) {
  site.value.siteTitle =
    props.siteTitle ||
    configs.siteTitle ||
    configs.siteName ||
    "技术支持：翊世信息";
}

useHead({
  titleTemplate: (title) =>
    `${title ? `${title} - ` : ""}${site.value.siteTitle}`,
  meta: [
    { charset: "utf-8" },
    {
      name: "viewport",
      content:
        props.viewport ||
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no",
    },
    {
      name: "title",
      content:
        props.siteTitle ||
        configs.siteTitle ||
        configs.siteName ||
        "mootcourt.cn 模拟法庭",
    },
    {
      name: "keywords",
      content: [
        props.siteTitle || configs.siteTitle || configs.siteName,
        "mootcourt.cn",
        "模拟法庭",
        "全国大学生模拟法庭",
        "比赛报名",
        "比赛资讯",
      ].join(","),
    },
    {
      property: "og:site_name",
      content: site.value.title || site.value.ownerName || configs.siteName,
    },
  ],
});
</script>

<template lang="pug" scoped>
div
  slot
    nuxt-page
</template>

<style lang="scss">
html,
body {
  font-family: "Noto Sans CJK SC", sans-serif;
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #000;
  line-height: 1.6;
}

.flex-1px {
  flex: 1 0 1px;
}

.flex-auto {
  flex: 0 0 auto;
}
</style>
